module.exports = __webpack_public_path__ + "assets/cf296776dd330265a1f4c848d059d8f4.png";